// extracted by mini-css-extract-plugin
module.exports = {"pagination":"PaginationItem_pagination__3c7yp","hide":"PaginationItem_hide__23I4o","hideOnMobile":"PaginationItem_hideOnMobile__12Cxd"};